import type { InjectionKey, Ref } from 'vue'
import type { UsePromotionGamesReturn } from './UsePromotionGames'
import type { JackpotGameMap } from './UseJackpot'
import type { MaybeRefOrGetter, useDayjs } from '#imports'

type Dayjs = ReturnType<ReturnType<typeof useDayjs>>

export interface UseGameListJackpotsQuery {
    gamesJackpots: Ref<Record<string, JackpotGameMap> | undefined>
}

/**
 * Shared context exposed by {@link useGameList} and consumed by
 * {@link useGameTile} via inject. Holds the list-scoped queries and the
 * single ticking clock that drives per-tile opening-hour countdowns.
 */
export interface UseGameListReturn {
    jackpotsQuery: UseGameListJackpotsQuery
    promotionQuery: UsePromotionGamesReturn
    now: Readonly<Ref<Dayjs>>
}

export interface UseGameListOptions {
    enableJackpots?: MaybeRefOrGetter<boolean | 'auto'>
}

export const GameListKey: InjectionKey<UseGameListReturn> = Symbol('GameList')
